import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ChannelCard } from '../../models/shared.models';

// Duplicated in subscription-card-list.component.ts
const MAX_CARD_COLUMNS = 3;

@Component({
    selector: 'app-channels-card-list',
    templateUrl: './channels-card-list.component.html',
    styleUrls: ['./channels-card-list.component.scss'],
    standalone: false
})
export class ChannelsCardListComponent {
  @Input() channels: Array<ChannelCard>;
  @Input() showSubtitle = true;

  @Output() clickChannel: EventEmitter<ChannelCard> = new EventEmitter<ChannelCard>();

  public readonly maxCardColumns = MAX_CARD_COLUMNS;

  constructor() { }

  public onClickChannel(channel: ChannelCard): void {
    this.clickChannel.emit(channel);
  }

}
